import loader from '../moduleLoader.js';
import './styles.css';
import SimpleScrollbar from 'simple-scrollbar';

function Dropdown(container) {
    var trigger;
    var area;

    function init() {
        trigger = container.querySelector('.dropdown__control');
        area = container.querySelector('.dropdown__area');
        var selectTriggers = container.querySelectorAll('.dropdown__select-trigger');
        var id = '_' + Math.random().toString(36).substr(2, 9);
        container.setAttribute('data-dropdown-expanded', 'false')
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', id);
        area.setAttribute('id', id);
        trigger.addEventListener('click', handleTriggerClick);
        if(container.querySelectorAll('input:checked').length > 0) {
            // trigger.classList.add('dropdown__control--selected');
        }
        selectTriggers.forEach(trigger => {
            trigger.addEventListener('click', handleSelectClick);
        });
        document.body.addEventListener('collapse-all-dropdowns', () => {
            collapse();
        });
        SimpleScrollbar.initEl(area);
    }
    function handleOutsideClick(e) {
        collapse();
    }
    function handleTriggerClick(e) {
        e.preventDefault();
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        isExpanded ? collapse() : expand();
    }
    function handleSelectClick(e) {
        var text = container.querySelector('.dropdown__control__text');
        if(text && this.dataset.selectTriggerText) {
            text.innerHTML = this.dataset.selectTriggerText;
        }
        // if(document.getElementById(this.getAttribute('for')).value != "") {
        //     trigger.classList.add('dropdown__control--selected');
        // }
        // else {
        //     trigger.classList.remove('dropdown__control--selected');
        // }
        collapse();
    }
    function handleAreaClick(e) {
        e.stopPropagation();
    }
    function handleEscKeyPress(e) {
        if(e.keyCode == 27) {
            collapse();
        }
    }
    function expand() {
        document.body.dispatchEvent(new CustomEvent('collapse-all-dropdowns'));
        trigger.setAttribute('aria-expanded', 'true');
        container.setAttribute('data-dropdown-expanded', 'true');
        container.addEventListener('click', handleAreaClick);
        document.body.addEventListener('click', handleOutsideClick);
        document.addEventListener('keydown', handleEscKeyPress);
    }
    function collapse() {
        trigger.setAttribute('aria-expanded', 'false');
        container.setAttribute('data-dropdown-expanded', 'false');
        container.removeEventListener('click', handleAreaClick);
        document.body.removeEventListener('click', handleOutsideClick);
        document.removeEventListener('keydown', handleEscKeyPress);
    }
    return {
        init: init
    }
}
 loader.add('Dropdown', Dropdown);
 export default Dropdown;